import { API_CONFIG } from "@/shared/configs/apiConfig.js"
export default {
  url({ type, period, companyId }) {
    const id = companyId || 'rapidoo'
    const periodKeys = {
      year: { key: 'month', limit: 12 },
      week: { key: 'day', limit: 7 },
      month: { key: 'day', limit: 30 },
    }
    const pk = periodKeys[period]
    return `${API_CONFIG.BASE_URLS.PAYMENT}/stats/${id}/${pk.key}/${pk.limit}?group=${API_CONFIG.GROUP}&service=rapidoo&type=momoVsCashStats&subType=${type}`
  },

  parse(raw = {}, payload = { type: '', period: '' }) {
    console.log('🚀 ~ momoVsCashStat ~ raw:', raw)
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        data: { count: 0 },
        currency: 'XOF',
      }
    }

    // Somme de tous les count pour la période
    const totalCount = (raw.data || []).reduce((sum, el) => sum + (el.count || 0), 0)

    return {
      statusCode: 200,
      data: { count: totalCount },
      currency: 'XOF',
    }
  },
}
